export default __webpack_public_path__ + "content/8c0654ce3443493bc4ffbe97e5f1d534.jpg";